import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import PublicLayout from "./layouts/PublicLayout";
import HomePage from "./pages/public/HomePage";
import EnquireFormPage from "./pages/public/EnquireFormPage";
import EnquireConfirmationPage from "./pages/public/EnquireConfirmationPage";

/**
 * Client portal — public (unauthenticated) routes (F1.5-2). The authenticated client portal is
 * Phase 3 (out of scope); every route here is public.
 */
export default function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route element={<PublicLayout />}>
          <Route index element={<HomePage />} />
          <Route path="enquire" element={<EnquireFormPage />} />
          <Route path="enquire/confirmation" element={<EnquireConfirmationPage />} />
          <Route path="*" element={<Navigate to="/" replace />} />
        </Route>
      </Routes>
    </BrowserRouter>
  );
}
